import { fetchOrganisationListPage } from '../../intervene/adapters/organisationListAdapter';
import { computeHasMore } from '../../../components/ui/SearchableSelect/selectUtils';
import { templateService } from '../services/templateService';
import { mapBotToSelectOption } from '../utils/normalizeTemplate';

export { fetchOrganisationListPage };

export async function fetchBotNumberListPage({ page, pageSize, search = '', extraParams = {}, signal }) {
  const companyId = extraParams.organisation_id ?? extraParams.company_id;
  if (!companyId) {
    return { items: [], totalCount: 0, hasMore: false };
  }

  const res = await templateService.getBotNumbers(companyId);
  if (res?.status !== 200 && res?.status !== 201) {
    throw new Error('Failed to load bot numbers');
  }

  const rawList = Array.isArray(res.data) ? res.data : res.data?.list ?? res.data?.results ?? [];
  const normalizedSearch = String(search ?? '').trim().toLowerCase();
  let items = rawList.map(mapBotToSelectOption).filter(Boolean);

  if (normalizedSearch) {
    items = items.filter(
      (item) =>
        item.label?.toLowerCase().includes(normalizedSearch) ||
        item.wa_phone_number?.includes(normalizedSearch)
    );
  }

  const start = (page - 1) * pageSize;
  const paged = items.slice(start, start + pageSize);

  return {
    items: paged,
    totalCount: items.length,
    hasMore: computeHasMore({
      page,
      pageSize,
      itemsLength: paged.length,
      totalCount: items.length,
    }),
  };
}
